import React from 'react';
import './Features.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import IconList from '../../components/IconList/IconList';
import featuresData from './FeaturesData';

const Features = () => {
    return (
        <section className='section-bg section-common features-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
            <SectionTitle 
             subTitle="Features" 
             title="Specialized Care Through Experience" 
             description="Our team of skilled professionals brings years of experience in providing specialized care for every patient. We focus on personalized treatments tailored to your needs, ensuring that each visit is comfortable and effective. From advanced dental procedures to routine checkups, we combine expertise and compassion for exceptional outcomes."/>

                <div className="row align-items-center">
                    {
                        featuresData.map(singleFeature => 
                            <IconList 
                                icon={singleFeature.icon} 
                                title={singleFeature.title}
                                description={singleFeature.description}
                            />
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Features;